let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5TrzL")).then(() => parcelRequire('hyWOU'));